import LoginEmail from '../components/loginpage/LoginEmail';

const LoginEmailPage = () => {
    return (
        <>
            <LoginEmail />
        </>
    );
};

export default LoginEmailPage;
